/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Readable } from '../models/readable';
import { reportsControllerCreateStaticReportSection } from '../fn/reports-controller/reports-controller-create-static-report-section';
import { ReportsControllerCreateStaticReportSection$Params } from '../fn/reports-controller/reports-controller-create-static-report-section';
import { reportsControllerDeleteStaticReportSection } from '../fn/reports-controller/reports-controller-delete-static-report-section';
import { ReportsControllerDeleteStaticReportSection$Params } from '../fn/reports-controller/reports-controller-delete-static-report-section';
import { reportsControllerGetStaticReportSection } from '../fn/reports-controller/reports-controller-get-static-report-section';
import { ReportsControllerGetStaticReportSection$Params } from '../fn/reports-controller/reports-controller-get-static-report-section';
import { reportsControllerGetStaticReportSectionFile } from '../fn/reports-controller/reports-controller-get-static-report-section-file';
import { ReportsControllerGetStaticReportSectionFile$Params } from '../fn/reports-controller/reports-controller-get-static-report-section-file';
import { reportsControllerPdfReportGeneration } from '../fn/reports-controller/reports-controller-pdf-report-generation';
import { ReportsControllerPdfReportGeneration$Params } from '../fn/reports-controller/reports-controller-pdf-report-generation';
import { reportsControllerUpdateStaticReportSectionFile } from '../fn/reports-controller/reports-controller-update-static-report-section-file';
import { ReportsControllerUpdateStaticReportSectionFile$Params } from '../fn/reports-controller/reports-controller-update-static-report-section-file';
import { reportsControllerUploadSection } from '../fn/reports-controller/reports-controller-upload-section';
import { ReportsControllerUploadSection$Params } from '../fn/reports-controller/reports-controller-upload-section';
import { StaticReportSectionGetById } from '../models/static-report-section-get-by-id';


/**
 * Represents an API resource used to generate project reports.
 */
@Injectable({ providedIn: 'root' })
export class ReportsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportsControllerUploadSection()` */
  static readonly ReportsControllerUploadSectionPath = '/planning-projects/v1-preview/reports/{projectId}/upload-section';

  /**
   * [DEPRECATED] Uploads PDF files that are merged with others to create a full project report. Endpoint will be removed soon.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerUploadSection()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   *
   * @deprecated
   */
  reportsControllerUploadSection$Response(params: ReportsControllerUploadSection$Params, context?: HttpContext): Observable<StrictHttpResponse<StaticReportSectionGetById>> {
    return reportsControllerUploadSection(this.http, this.rootUrl, params, context);
  }

  /**
   * [DEPRECATED] Uploads PDF files that are merged with others to create a full project report. Endpoint will be removed soon.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerUploadSection$Response()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   *
   * @deprecated
   */
  reportsControllerUploadSection(params: ReportsControllerUploadSection$Params, context?: HttpContext): Observable<StaticReportSectionGetById> {
    return this.reportsControllerUploadSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<StaticReportSectionGetById>): StaticReportSectionGetById => r.body)
    );
  }

  /** Path part for operation `reportsControllerCreateStaticReportSection()` */
  static readonly ReportsControllerCreateStaticReportSectionPath = '/planning-projects/v1-preview/reports/static-report-sections';

  /**
   * Creates new static report PDF file section. Sections are used as the static pages or placeholders in the final reports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerCreateStaticReportSection()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   */
  reportsControllerCreateStaticReportSection$Response(params: ReportsControllerCreateStaticReportSection$Params, context?: HttpContext): Observable<StrictHttpResponse<StaticReportSectionGetById>> {
    return reportsControllerCreateStaticReportSection(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates new static report PDF file section. Sections are used as the static pages or placeholders in the final reports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerCreateStaticReportSection$Response()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   */
  reportsControllerCreateStaticReportSection(params: ReportsControllerCreateStaticReportSection$Params, context?: HttpContext): Observable<StaticReportSectionGetById> {
    return this.reportsControllerCreateStaticReportSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<StaticReportSectionGetById>): StaticReportSectionGetById => r.body)
    );
  }

  /** Path part for operation `reportsControllerGetStaticReportSection()` */
  static readonly ReportsControllerGetStaticReportSectionPath = '/planning-projects/v1-preview/reports/static-report-sections/{id}';

  /**
   * Returns a static report section record by it's ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerGetStaticReportSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerGetStaticReportSection$Response(params: ReportsControllerGetStaticReportSection$Params, context?: HttpContext): Observable<StrictHttpResponse<StaticReportSectionGetById>> {
    return reportsControllerGetStaticReportSection(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a static report section record by it's ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerGetStaticReportSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerGetStaticReportSection(params: ReportsControllerGetStaticReportSection$Params, context?: HttpContext): Observable<StaticReportSectionGetById> {
    return this.reportsControllerGetStaticReportSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<StaticReportSectionGetById>): StaticReportSectionGetById => r.body)
    );
  }

  /** Path part for operation `reportsControllerDeleteStaticReportSection()` */
  static readonly ReportsControllerDeleteStaticReportSectionPath = '/planning-projects/v1-preview/reports/static-report-sections/{id}';

  /**
   * Removes a static report section record and related file by it's ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerDeleteStaticReportSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerDeleteStaticReportSection$Response(params: ReportsControllerDeleteStaticReportSection$Params, context?: HttpContext): Observable<StrictHttpResponse<StaticReportSectionGetById>> {
    return reportsControllerDeleteStaticReportSection(this.http, this.rootUrl, params, context);
  }

  /**
   * Removes a static report section record and related file by it's ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerDeleteStaticReportSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerDeleteStaticReportSection(params: ReportsControllerDeleteStaticReportSection$Params, context?: HttpContext): Observable<StaticReportSectionGetById> {
    return this.reportsControllerDeleteStaticReportSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<StaticReportSectionGetById>): StaticReportSectionGetById => r.body)
    );
  }

  /** Path part for operation `reportsControllerGetStaticReportSectionFile()` */
  static readonly ReportsControllerGetStaticReportSectionFilePath = '/planning-projects/v1-preview/reports/static-report-sections/{id}/files';

  /**
   * Returns a static report section PDF file by the ID of the section.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerGetStaticReportSectionFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerGetStaticReportSectionFile$Response(params: ReportsControllerGetStaticReportSectionFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
    return reportsControllerGetStaticReportSectionFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a static report section PDF file by the ID of the section.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerGetStaticReportSectionFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerGetStaticReportSectionFile(params: ReportsControllerGetStaticReportSectionFile$Params, context?: HttpContext): Observable<Readable> {
    return this.reportsControllerGetStaticReportSectionFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Readable>): Readable => r.body)
    );
  }

  /** Path part for operation `reportsControllerUpdateStaticReportSectionFile()` */
  static readonly ReportsControllerUpdateStaticReportSectionFilePath = '/planning-projects/v1-preview/reports/static-report-sections/{id}/files';

  /**
   * Replaces a static report section content by new PDF file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerUpdateStaticReportSectionFile()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   */
  reportsControllerUpdateStaticReportSectionFile$Response(params: ReportsControllerUpdateStaticReportSectionFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reportsControllerUpdateStaticReportSectionFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Replaces a static report section content by new PDF file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerUpdateStaticReportSectionFile$Response()` instead.
   *
   * This method sends `application/pdf` and handles request body of type `application/pdf`.
   */
  reportsControllerUpdateStaticReportSectionFile(params: ReportsControllerUpdateStaticReportSectionFile$Params, context?: HttpContext): Observable<void> {
    return this.reportsControllerUpdateStaticReportSectionFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsControllerPdfReportGeneration()` */
  static readonly ReportsControllerPdfReportGenerationPath = '/planning-projects/v1-preview/reports/pdf';

  /**
   * Endpoint which generates the PDF report for given project ID.
   *     <p>Additional actions:
   *         <ul>
   *             <li>Import an external project from Salesforce when it's necessary (main opportunity / child opportunity).</li>
   *             <li>If the report is a "PITCH_DECK" report type, it is automatically uploaded to Salesforce.</li>
   *         </ul>
   *     </p>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsControllerPdfReportGeneration()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerPdfReportGeneration$Response(params: ReportsControllerPdfReportGeneration$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
    return reportsControllerPdfReportGeneration(this.http, this.rootUrl, params, context);
  }

  /**
   * Endpoint which generates the PDF report for given project ID.
   *     <p>Additional actions:
   *         <ul>
   *             <li>Import an external project from Salesforce when it's necessary (main opportunity / child opportunity).</li>
   *             <li>If the report is a "PITCH_DECK" report type, it is automatically uploaded to Salesforce.</li>
   *         </ul>
   *     </p>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsControllerPdfReportGeneration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsControllerPdfReportGeneration(params: ReportsControllerPdfReportGeneration$Params, context?: HttpContext): Observable<Readable> {
    return this.reportsControllerPdfReportGeneration$Response(params, context).pipe(
      map((r: StrictHttpResponse<Readable>): Readable => r.body)
    );
  }

}
